/* eslint-disable react/no-array-index-key */
import {
  Stack,
  TextField,
  Button,
  Container,
  Typography,
  Paper,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  LinearProgress,
  FormControl,
  Autocomplete,
  InputLabel,
  Select,
  MenuItem,
  Collapse,
  Snackbar,
  Alert,
  Slide,
  IconButton,
  Grid,
  Box,
  Chip,
  Tooltip,
  Fade,
  Badge,
  InputAdornment,
  Divider,
  ToggleButton,
  ToggleButtonGroup,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  Avatar,
  Menu,
} from '@mui/material';
import * as XLSX from 'xlsx';
import XLSXS from 'xlsx-js-style';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import LockResetIcon from '@mui/icons-material/LockReset';
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import JsPDF from 'jspdf';
import 'jspdf-autotable';
import axios from '../axios';

// Styled components - matching blog/review/casestudy patterns
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  color: '#fff',
  fontWeight: 700,
  textAlign: 'left',
  backgroundColor: '#1a3a4a',
  padding: '12px 16px',
  whiteSpace: 'nowrap',
  fontSize: '0.8rem',
  letterSpacing: '0.03em',
  borderBottom: '2px solid rgba(255,255,255,0.1)',
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
  },
  '&:hover': {
    backgroundColor: 'rgba(25, 118, 210, 0.04)',
    transition: 'background-color 0.2s ease',
  },
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
  overflow: 'hidden',
  border: '1px solid #e8ecf0',
}));

const HeaderPaper = styled(Paper)(({ theme }) => ({
  background: 'linear-gradient(135deg, #134e5e 0%, #71b280 100%)',
  borderRadius: '12px',
  padding: '16px 24px',
  marginBottom: '16px',
  boxShadow: '0 4px 20px rgba(19, 78, 94, 0.3)',
}));

const FilterAccordion = styled(Paper)(({ theme }) => ({
  border: '1px solid #e8ecf0',
  borderRadius: '12px',
  marginBottom: '16px',
  overflow: 'hidden',
  '& .MuiAccordion-root': {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
  },
  '& .MuiAccordionSummary-root': {
    padding: '0 16px',
    minHeight: '56px',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.02)',
    },
  },
  '& .MuiAccordionDetails-root': {
    padding: '0 16px 20px 16px',
  },
}));

const EnquiryCard = styled(Card)(({ theme }) => ({
  borderRadius: '12px',
  transition: 'all 0.3s ease',
  border: '1px solid #e8ecf0',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
  },
}));

function formatDate(inputDateTime) {
  if (!inputDateTime) return '';
  const isoDate = new Date(inputDateTime);
  if (Number.isNaN(isoDate.getTime())) return '';
  const day = isoDate.getUTCDate().toString().padStart(2, '0');
  const month = (isoDate.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = isoDate.getUTCFullYear();
  let hour = isoDate.getUTCHours();
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour %= 12;
  hour = hour || 12;
  const minute = isoDate.getUTCMinutes().toString().padStart(2, '0');
  return `${day}/${month}/${year} ${hour}:${minute} ${ampm}`;
}

function formatDateToinitialValues(date) {
  if (!date) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Get current date and first day of current month
const currentDate = new Date();
const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
const initialFromDate = formatDateToinitialValues(firstDayOfMonth);
const initialToDate = formatDateToinitialValues(currentDate);

const WebEnquiriesReports = () => {
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';

  const [showNoResultsSnackbar, setShowNoResultsSnackbar] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openLoader, setOpenLoader] = useState(false);
  const [expanded, setExpanded] = useState(true);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedType, setSelectedType] = useState({ Type: 'All' });
  const [selectedProduct, setSelectedProduct] = useState({ Product: 'All' });
  const [productsData, setProductsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState('table');

  // Filter menu
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);

  // Initialize filters with current month dates
  const [filters, setFilters] = useState({
    fromDate: initialFromDate,
    toDate: initialToDate,
    Type: '',
    Product: '',
  });

  useEffect(() => {
    getAllData();
    GetProducts();
  }, []);

  // Auto-apply filters when data loads
  useEffect(() => {
    if (allData.length > 0) {
      applyFilters();
    }
  }, [allData]);

  const getAllData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetallWebEnquiryForMIS', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setAllData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setOpenLoader(false);
    }
  };

  const GetProducts = async () => {
    try {
      const res = await axios.instance.get('/GetProducts', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setProductsData(res.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const getTypeLabel = (type) => {
    const types = {
      d: { label: 'Brochure', color: 'info' },
      p: { label: 'Product', color: 'primary' },
      s: { label: 'Service', color: 'success' },
      c: { label: 'Partnership', color: 'warning' },
    };
    return types[type] || { label: 'Unknown', color: 'default' };
  };

  const handleDownloadPDF = () => {
    const doc = new JsPDF();
    doc.setFontSize(16);
    doc.text('Web Enquiries Report', 14, 20);
    doc.setFontSize(10);
    doc.text(`Generated: ${new Date().toLocaleString()}`, 14, 28);

    const headers = ['S.No', 'Date', 'Name', 'Company', 'Phone', 'Email', 'City', 'Type', 'Product'];
    const data = filteredData.map((enq, index) => [
      index + 1,
      enq.CreatedDate ? formatDate(enq.CreatedDate) : '',
      enq.UserName || '',
      enq.CompanyName || '',
      enq.PhoneNumber || '',
      enq.Email || '',
      enq.City || '',
      getTypeLabel(enq.TypeOfReq).label,
      enq.Product || '',
    ]);

    doc.autoTable({
      head: [headers],
      body: data,
      startY: 35,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [26, 58, 74] },
    });
    doc.save(`Enquiries_${formatDateToinitialValues(new Date())}.pdf`);
  };

  const handleDownloadExcel = () => {
    const data = filteredData.map((enq, index) => ({
      'S.No': index + 1,
      'Enquiry ID': enq.EnquiryId,
      Date: formatDate(enq.CreatedDate),
      Name: enq.UserName,
      Company: enq.CompanyName,
      Phone: enq.PhoneNumber,
      Email: enq.Email,
      City: enq.City,
      Country: enq.Country,
      Type: getTypeLabel(enq.TypeOfReq).label,
      Product: enq.Product,
      Remarks: enq.Remarks || '',
    }));

    const wb = XLSXS.utils.book_new();
    const ws = XLSXS.utils.json_to_sheet(data, { origin: 'A8' });

    const maxColWidths = {};
    data.forEach((row) => {
      Object.keys(row).forEach((col) => {
        const cellValue = row[col] ? row[col].toString() : '';
        maxColWidths[col] = Math.max(maxColWidths[col] || 0, cellValue.length + 15);
      });
    });
    ws['!cols'] = Object.keys(maxColWidths).map((col) => ({ wch: maxColWidths[col] }));

    XLSXS.utils.book_append_sheet(wb, ws, 'Enquiry Data');
    XLSXS.writeFile(wb, `Enquiries_${formatDateToinitialValues(new Date())}.xlsx`);
  };

  const resetFilters = () => {
    setFilters({
      fromDate: initialFromDate,
      toDate: initialToDate,
      Type: '',
      Product: '',
    });
    setSearchQuery('');
    setSelectedType({ Type: 'All' });
    setSelectedProduct({ Product: 'All' });
    setFilteredData([]);
    // Re-apply filters after reset
    setTimeout(() => {
      applyFilters();
    }, 100);
  };

  const applyFilters = () => {
    let filtered = allData.filter((enq) => {
      const enqDate = new Date(enq.CreatedDate);
      enqDate.setHours(0, 0, 0, 0);
      const fromDate = new Date(filters.fromDate);
      fromDate.setHours(0, 0, 0, 0);
      const toDate = new Date(filters.toDate);
      toDate.setHours(0, 0, 0, 0);

      const dateFilterPassed = !filters.fromDate || !filters.toDate || (enqDate >= fromDate && enqDate <= toDate);
      const productFilterPassed =
        !filters.Product || enq.Product?.toLowerCase().includes(filters.Product.toLowerCase());
      const typeFilterPassed = !filters.Type || enq.TypeOfReq?.toLowerCase() === filters.Type.toLowerCase();

      return dateFilterPassed && productFilterPassed && typeFilterPassed;
    });

    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter((enq) =>
        Object.values(enq).some((value) => typeof value === 'string' && value.toLowerCase().includes(query))
      );
    }

    setFilteredData(filtered);
    if (filtered.length === 0) {
      setShowNoResultsSnackbar(true);
    } else {
      setShowNoResultsSnackbar(false);
      setExpanded(false);
    }
  };

  const handleExpansion = () => {
    setExpanded((prev) => !prev);
  };

  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1));

  const handleCloseSnackbar = () => {
    setShowNoResultsSnackbar(false);
  };

  const getActiveFilterCount = () => {
    let count = 0;
    if (filters.Type) count += 1;
    if (filters.Product) count += 1;
    if (filters.fromDate !== initialFromDate || filters.toDate !== initialToDate) count += 1;
    if (searchQuery) count += 1;
    return count;
  };

  const handleFilterOpen = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  // Render card view - matching blog/casestudy style
  const renderCardView = () => {
    const displayData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
      <Grid container spacing={3}>
        {displayData.map((enq, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Fade in timeout={400}>
              <EnquiryCard>
                <Box
                  sx={{
                    p: 2,
                    bgcolor: 'primary.light',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Avatar sx={{ bgcolor: 'primary.main', width: 40, height: 40 }}>
                      <PersonIcon />
                    </Avatar>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>
                        {enq.UserName || 'Unknown'}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {formatDate(enq.CreatedDate)}
                      </Typography>
                    </Box>
                  </Stack>
                  {enq.TypeOfReq && (
                    <Chip
                      label={getTypeLabel(enq.TypeOfReq).label}
                      size="small"
                      color={getTypeLabel(enq.TypeOfReq).color}
                      sx={{ fontWeight: 600 }}
                    />
                  )}
                </Box>

                <CardContent sx={{ pt: 2 }}>
                  <Stack spacing={1.5}>
                    {enq.CompanyName && (
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <BusinessIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                        <Typography variant="body2">{enq.CompanyName}</Typography>
                      </Stack>
                    )}
                    {enq.PhoneNumber && (
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <CallIcon sx={{ fontSize: 16, color: 'success.main' }} />
                        <Button
                          component="a"
                          href={`tel:+91${enq.PhoneNumber}`}
                          sx={{ color: 'inherit', textTransform: 'none', fontSize: '0.85rem', p: 0 }}
                        >
                          {enq.PhoneNumber}
                        </Button>
                      </Stack>
                    )}
                    {enq.Email && (
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <EmailIcon sx={{ fontSize: 16, color: 'error.main' }} />
                        <Button
                          component="a"
                          href={`mailto:${enq.Email}`}
                          sx={{ color: 'inherit', textTransform: 'none', fontSize: '0.85rem', p: 0 }}
                        >
                          {enq.Email}
                        </Button>
                      </Stack>
                    )}
                    {enq.City && (
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <LocationOnIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                        <Typography variant="body2">{enq.City}</Typography>
                      </Stack>
                    )}
                    {enq.Product && (
                      <Chip label={enq.Product} size="small" variant="outlined" sx={{ alignSelf: 'flex-start' }} />
                    )}
                  </Stack>
                </CardContent>
              </EnquiryCard>
            </Fade>
          </Grid>
        ))}
      </Grid>
    );
  };

  return (
    <>
      <Container maxWidth="xl" sx={{ pt: 3, pb: 4 }}>
        <Snackbar
          open={showNoResultsSnackbar}
          autoHideDuration={4000}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity="info" variant="filled" sx={{ borderRadius: 2 }}>
            No results found for the applied filters
          </Alert>
        </Snackbar>

        {/* Header - Consistent with Case Study Master */}
        <HeaderPaper elevation={0}>
          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center">
            <Stack direction="row" alignItems="center" spacing={1}>
              <AnalyticsIcon sx={{ color: 'white' }} />
              <Typography variant="h6" fontWeight={700} color="white" sx={{ letterSpacing: '0.02em' }}>
                Web Enquiries Report
              </Typography>
            </Stack>
            <Typography variant="caption" color="rgba(255,255,255,0.7)">
              Total: {allData.length} enquiries
            </Typography>
          </Stack>
        </HeaderPaper>

        {/* Filters */}
        <FilterAccordion elevation={0}>
          <Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ px: 2, py: 1, cursor: 'pointer' }}
              onClick={handleExpansion}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <FilterAltIcon sx={{ color: '#36BA98' }} />
                <Typography variant="subtitle1" fontWeight={600} color="#36BA98">
                  Filters
                </Typography>
                {getActiveFilterCount() > 0 && (
                  <Badge badgeContent={getActiveFilterCount()} color="primary" sx={{ ml: 1 }} />
                )}
              </Stack>
              <IconButton size="small" sx={{ color: '#36BA98' }}>
                <ExpandMoreIcon sx={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: '0.3s' }} />
              </IconButton>
            </Stack>

            <Collapse in={expanded}>
              <Box sx={{ px: 2, pb: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={3}>
                    <Autocomplete
                      size="small"
                      fullWidth
                      options={[{ Product: 'All' }, ...productsData]}
                      getOptionLabel={(opt) => opt.Product || 'All'}
                      isOptionEqualToValue={(opt, val) => opt.Product === val.Product}
                      renderInput={(params) => <TextField {...params} label="Product" variant="outlined" />}
                      value={selectedProduct}
                      onChange={(e, newValue) => {
                        setSelectedProduct(newValue);
                        setFilters({
                          ...filters,
                          Product: newValue?.Product === 'All' ? '' : newValue?.Product || '',
                        });
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <FormControl size="small" fullWidth>
                      <InputLabel>Type</InputLabel>
                      <Select
                        value={filters.Type || 'All'}
                        label="Type"
                        onChange={(e) => {
                          const val = e.target.value;
                          setFilters({ ...filters, Type: val === 'All' ? '' : val });
                        }}
                      >
                        <MenuItem value="All">All</MenuItem>
                        <MenuItem value="d">Brochure</MenuItem>
                        <MenuItem value="p">Product</MenuItem>
                        <MenuItem value="s">Service</MenuItem>
                        <MenuItem value="c">Partnership</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="From Date"
                      type="date"
                      value={filters.fromDate}
                      onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="To Date"
                      type="date"
                      value={filters.toDate}
                      onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Stack direction="row" spacing={1}>
                      <Button
                        variant="contained"
                        onClick={applyFilters}
                        startIcon={<FilterAltIcon />}
                        sx={{ flex: 1, borderRadius: 2 }}
                      >
                        Apply
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={resetFilters}
                        startIcon={<LockResetIcon />}
                        sx={{ borderRadius: 2 }}
                      >
                        Reset
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>
            </Collapse>
          </Stack>
        </FilterAccordion>

        {/* Search & Export Bar */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          sx={{ mb: 2 }}
        >
          <TextField
            placeholder="Search enquiries..."
            size="small"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{ maxWidth: { sm: 300 }, width: '100%' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" color="action" />
                </InputAdornment>
              ),
              endAdornment: searchQuery && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchQuery('')}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            onKeyPress={(e) => e.key === 'Enter' && applyFilters()}
          />

          <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
            <ToggleButtonGroup
              value={viewMode}
              exclusive
              onChange={(e, val) => val && setViewMode(val)}
              size="small"
              sx={{ '& .MuiToggleButton-root': { px: 1.5 } }}
            >
              <ToggleButton value="table">
                <ViewListIcon fontSize="small" />
              </ToggleButton>
              <ToggleButton value="grid">
                <ViewModuleIcon fontSize="small" />
              </ToggleButton>
            </ToggleButtonGroup>

            {filteredData.length > 0 && (
              <>
                <Button
                  variant="contained"
                  color="success"
                  startIcon={<DownloadForOfflineIcon />}
                  onClick={handleDownloadExcel}
                  size="small"
                  sx={{ borderRadius: 2 }}
                >
                  Excel
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  startIcon={<PictureAsPdfIcon />}
                  onClick={handleDownloadPDF}
                  size="small"
                  sx={{ borderRadius: 2 }}
                >
                  PDF
                </Button>
              </>
            )}
          </Stack>
        </Stack>

        {/* Results count */}
        {filteredData.length > 0 && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
            Showing {filteredData.length} result{filteredData.length !== 1 ? 's' : ''}
          </Typography>
        )}

        {/* Content */}
        {filteredData.length === 0 ? (
          <Paper sx={{ textAlign: 'center', py: 6, borderRadius: 3 }}>
            <Typography variant="h6" color="text.secondary">
              No enquiries found
            </Typography>
            <Typography variant="body2" color="text.disabled">
              Try adjusting your filters or search terms
            </Typography>
          </Paper>
        ) : viewMode === 'grid' ? (
          <>
            {renderCardView()}
            <TablePagination
              rowsPerPageOptions={[6, 12, 24]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={Math.min(page, Math.ceil(totalRows / rowsPerPage) - 1)}
              onPageChange={(e, newPage) => setPage(newPage)}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
              sx={{ mt: 2 }}
            />
          </>
        ) : (
          <StyledPaper elevation={0}>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center" sx={{ width: 60 }}>
                      #
                    </StyledTableCell>
                    <StyledTableCell>Date & Time</StyledTableCell>
                    <StyledTableCell>Name</StyledTableCell>
                    <StyledTableCell>Company</StyledTableCell>
                    <StyledTableCell>Phone</StyledTableCell>
                    <StyledTableCell>Email</StyledTableCell>
                    <StyledTableCell>City</StyledTableCell>
                    <StyledTableCell>Type</StyledTableCell>
                    <StyledTableCell>Product</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(rowsPerPage > 0
                    ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : filteredData
                  ).map((enq, index) => (
                    <StyledTableRow key={index}>
                      <TableCell align="center" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell sx={{ fontSize: '0.75rem', whiteSpace: 'nowrap' }}>
                        {formatDate(enq.CreatedDate)}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 500, fontSize: '0.85rem' }}>
                        <Stack direction="row" alignItems="center" spacing={0.5}>
                          <PersonIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                          <span>{enq.UserName || '-'}</span>
                        </Stack>
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" alignItems="center" spacing={0.5}>
                          <BusinessIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                          <span>{enq.CompanyName || '-'}</span>
                        </Stack>
                      </TableCell>
                      <TableCell>
                        <Button
                          component="a"
                          href={`tel:+91${enq.PhoneNumber}`}
                          startIcon={<CallIcon sx={{ fontSize: 16 }} />}
                          sx={{ color: 'inherit', textTransform: 'none', fontSize: '0.8rem', p: 0 }}
                        >
                          {enq.PhoneNumber || '-'}
                        </Button>
                      </TableCell>
                      <TableCell>
                        <Button
                          component="a"
                          href={`mailto:${enq.Email}`}
                          startIcon={<EmailIcon sx={{ fontSize: 16 }} />}
                          sx={{ color: 'inherit', textTransform: 'none', fontSize: '0.8rem', p: 0 }}
                        >
                          {enq.Email || '-'}
                        </Button>
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" alignItems="center" spacing={0.5}>
                          <LocationOnIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                          <span>{enq.City || '-'}</span>
                        </Stack>
                      </TableCell>
                      <TableCell>
                        {enq.TypeOfReq && (
                          <Chip
                            label={getTypeLabel(enq.TypeOfReq).label}
                            size="small"
                            color={getTypeLabel(enq.TypeOfReq).color}
                            sx={{ fontSize: '0.7rem', height: 24, borderRadius: 1 }}
                          />
                        )}
                      </TableCell>
                      <TableCell sx={{ fontSize: '0.8rem' }}>{enq.Product || '-'}</TableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={currentPage}
              onPageChange={(e, newPage) => setPage(newPage)}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
              sx={{ borderTop: '1px solid #e8ecf0' }}
            />
          </StyledPaper>
        )}
      </Container>

      {/* Loader */}
      <Dialog open={openLoader} fullWidth>
        <LinearProgress sx={{ height: 4 }} />
      </Dialog>
    </>
  );
};

export default WebEnquiriesReports;
